import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {NgxSpinnerService} from "ngx-spinner";
import {Enquiry} from "@/models/enquiry/Enquiry";
import {UntypedFormGroup, UntypedFormControl, UntypedFormArray, Validators,} from "@angular/forms";
import {ProductDetails, ProductVariantDetail} from "@/modals/product-details";
import {AppService} from "@services/app.service";
import {ToastrService} from "ngx-toastr";
import {BillingDetails} from "@/models/billing/BillingDetails";
import * as CryptoJS from 'crypto-js';
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-invoice',
  templateUrl: './invoice.component.html',
  styleUrl: './invoice.component.scss'
})
export class InvoiceComponent implements OnInit, OnDestroy {
  customerEnquiry: Enquiry | undefined;
  invoiceFormGroup: UntypedFormGroup;
  invoiceDetails: BillingDetails | undefined;
  private secretKey = "#EVOL-&$%$DF%SION*^%#^*F&%^DFSEYUJ";

  //Indian State List
  states: string[] = [
    'Andaman and Nicobar Islands',
    'Andhra Pradesh',
    'Arunachal Pradesh',
    'Assam',
    'Bihar',
    'Chandigarh',
    'Chhattisgarh',
    'Dadra and Nagar Haveli and Daman and Diu',
    'Delhi',
    'Goa',
    'Gujarat',
    'Haryana',
    'Himachal Pradesh',
    'Jammu and Kashmir',
    'Jharkhand',
    'Karnataka',
    'Kerala',
    'Ladakh',
    'Lakshadweep',
    'Madhya Pradesh',
    'Maharashtra',
    'Manipur',
    'Meghalaya',
    'Mizoram',
    'Nagaland',
    'Odisha',
    'Puducherry',
    'Punjab',
    'Rajasthan',
    'Sikkim',
    'Tamil Nadu',
    'Telangana',
    'Tripura',
    'Uttar Pradesh',
    'Uttarakhand',
    'West Bengal'
  ];
  options: { value: string; label: string }[] = [];

  productVariants: { [index: number]: ProductVariantDetail[] } = [];
  sizes: ProductVariantDetail[] = [];
  productList: { [index: number]: ProductDetails[] } = {};

  constructor(private router: Router, private spinner: NgxSpinnerService, private appService: AppService, private toastr: ToastrService
  ) {
    this.states.sort();
  }


  ngOnInit() {
    this.customerEnquiry = JSON.parse(localStorage.getItem('lfCustomerDetail') || '{}');
    console.log(`customer::`, this.customerEnquiry);

    this.getFormGroup(this.customerEnquiry);

    const isEmpty = Object.keys(this.customerEnquiry).length === 0;

    // Set default value for billType
    this.invoiceFormGroup.get('billType')?.setValue(isEmpty ? 'OFFLINE' : 'ONLINE');
    this.invoiceFormGroup.get('paymentMethod')?.setValue(isEmpty ? 'CASH' : 'UPI');
    this.invoiceFormGroup.get('orderVia')?.setValue(isEmpty && this.invoiceFormGroup.controls['billType'].value == 'ONLINE' ? this.invoiceFormGroup.controls['orderVia'].value : 'Website');
    if (isEmpty) {
      this.options = [
        {value: 'Instagram', label: 'Instagram'},
        {value: 'Whatsapp', label: 'Whatsapp'},
        {value: 'Facebook', label: 'Facebook'}
      ];
    } else {
      this.options = [
        {value: 'Website', label: 'Website'}
      ];
    }
    this.invoiceFormGroup.get('billingStatus')?.setValue('PAID');

    this.productVariants[0] = this.customerEnquiry?.productDetails?.productVariantDetails
      ?.filter((variant, index, self) =>
        index === self.findIndex((t) => t.size === variant.size)
      );
  }

  get isOffline(): boolean {
    return this.invoiceFormGroup.get('billType')?.value !== 'OFFLINE';
  }

  allowOnlyNumbers(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  getFormGroup(enquiry: Enquiry) {
    const currentDate = new Date().toISOString().split('T')[0];
    this.invoiceFormGroup = new UntypedFormGroup({
      billId: new UntypedFormControl(''),
      customerName: new UntypedFormControl(enquiry?.customerName || '', [Validators.required, Validators.nullValidator]),
      phoneNumber: new UntypedFormControl(enquiry?.phoneNumber || '',[Validators.required, Validators.nullValidator,
        Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$"), Validators.minLength(10),
        Validators.maxLength(10)]),
      doorNo: new UntypedFormControl(enquiry?.doorNo || ''),
      street: new UntypedFormControl(enquiry?.street || ''),
      city: new UntypedFormControl(enquiry?.city || ''),
      state: new UntypedFormControl(enquiry?.state || ''),
      pincode: new UntypedFormControl(enquiry?.pincode || ''),
      subTotal: new UntypedFormControl(''),
      discount: new UntypedFormControl(''),
      totalAmount: new UntypedFormControl(''),
      invoiceDate: new UntypedFormControl(currentDate),
      billType: new UntypedFormControl(''),
      shopId: new UntypedFormControl(''),
      billingStatus: new UntypedFormControl(''),
      paymentMethod: new UntypedFormControl(''),
      createdAt: new UntypedFormControl(''),
      createdBy: new UntypedFormControl(''),
      updatedAt: new UntypedFormControl(''),
      updatedBy: new UntypedFormControl(''),
      userRegId: new UntypedFormControl(''),
      orderVia: new UntypedFormControl('', ),
      products: new UntypedFormArray([])
    })
    this.addItem(enquiry.productDetails);

    // Listen for changes in discount to update totalAmount
    this.invoiceFormGroup.get('discount')?.valueChanges.subscribe(() => this.updateTotalAmount());
  }


  //get products form array function from invoice form group
  get products() {
    return this.invoiceFormGroup.get('products') as UntypedFormArray;
  }


  //add form array based on form group
  addItem(products?: ProductDetails) {
    const isFirstItem = (this.invoiceFormGroup.get('products') as UntypedFormArray).length === 0;
    const productGroup = new UntypedFormGroup({
      billingItemId: new UntypedFormControl(''),
      billId: new UntypedFormControl(''),
      productId: new UntypedFormControl(isFirstItem ? products?.productId || '' : ''),
      productCode: new UntypedFormControl(isFirstItem ? products?.productCode || '' : ''),
      productName: new UntypedFormControl(isFirstItem ? products?.productName || '' : ''),
      size: new UntypedFormControl(''),
      enquiryId: new UntypedFormControl(this.customerEnquiry?.enquiryId || ''),
      quantity: new UntypedFormControl(1),
      unitPrice: new UntypedFormControl(''),
      totalPrice: new UntypedFormControl({value: '', readOnly: true}), // Auto-calculated
      createdAt: new UntypedFormControl(''),
      updatedAt: new UntypedFormControl(''),
    });
    console.log('Adding product:', products); // Debugging
    console.log('Product name in form:', productGroup.get('productName')?.value); // Check if it is set


    // Listen for changes in quantity and unitPrice to update totalPrice
    productGroup.get('quantity')?.valueChanges.subscribe(() => this.updateTotalPrice(productGroup));
    productGroup.get('unitPrice')?.valueChanges.subscribe(() => this.updateTotalPrice(productGroup));

    (this.invoiceFormGroup.get('products') as UntypedFormArray).push(productGroup);
    if (isFirstItem) {
      this.getAllProductsByProductCode(0);
    }
    this.updateSubTotal(); // Update subtotal when a new item is added
  }

  // Function to update total price and subTotal
  updateTotalPrice(productGroup: UntypedFormGroup) {
    const quantity = productGroup.get('quantity')?.value || 0;
    const unitPrice = productGroup.get('unitPrice')?.value || 0;
    const totalPrice = quantity * unitPrice;

    productGroup.get('totalPrice')?.setValue(totalPrice, {emitEvent: false});

    this.updateSubTotal(); // Update subtotal whenever price changes
  }

  // Function to calculate subtotal
  updateSubTotal() {
    const productsArray = this.invoiceFormGroup.get('products') as UntypedFormArray;
    let subTotal = 0;

    productsArray.controls.forEach(product => {
      const totalPrice = product.get('totalPrice')?.value || 0;
      subTotal += totalPrice;
    });

    this.invoiceFormGroup.get('subTotal')?.setValue(subTotal, {emitEvent: false});

    this.updateTotalAmount(); // Update total amount whenever subtotal changes
  }

  // Function to update totalAmount based on subTotal and discount
  updateTotalAmount() {
    const subTotal = this.invoiceFormGroup.get('subTotal')?.value || 0;
    const discount = this.invoiceFormGroup.get('discount')?.value || 0;
    const totalAmount = subTotal - discount;

    this.invoiceFormGroup.get('totalAmount')?.setValue(totalAmount, {emitEvent: false});
  }


  //remove products form array functionality
  removeItem(index: number) {
    if (this.products.length > 1) {
      this.products.removeAt(index);
    }
  }


  //get product code by index
  getProductCodeByIndex(index: number): string {
    console.log(this.products)
    return this.products.at(index).get('productCode')?.value || '';
  }


  //get all products by entered product code
  getAllProductsByProductCode(index: number) {
    console.log(index)
    const productCode = this.getProductCodeByIndex(index);
    console.log('Product Code:', productCode);
    this.appService.getAllProductsByProductCode(productCode)
      .subscribe({
        next: (response: ProductDetails[]) => {
          this.productList[index] = response;
          console.log(`Product list for index ${index}:`, this.productList[index]);
          if (response.length === 1) {
            const productNameControl = this.products.at(index).get('productName');
            productNameControl?.setValue(response[0].productName + "|" + response[0].productId);
            const productIdControl = this.products.at(index).get('productId');
            productIdControl?.setValue(response[0].productId);
            this.productVariants[index] = this.productList[index][0].productVariantDetails;
          }
        },
        error: (error) => {
          console.error('Error fetching product by product code:', error);
          this.toastr.error(error.error.message);
        },
        complete: () => {
          console.log('Enquiry product by product code completed');
        }
      });
  }

  productBasedSize(event: any, index: number) {
    const selectedValue = event.target.value;
    const [productName, productId] = selectedValue.split('|');
    const productNameControl = this.products.at(index).get('productName');
    productNameControl?.setValue(productName + '|' + productId, {emitEvent: true});
    const productIdControl = this.products.at(index).get('productId');
    productIdControl?.setValue(productId);
    console.log(productNameControl.value, productName)
    this.productVariants[index] = Array.from(
      new Set(
        this.productList[index]
          .find(name => name.productId == productId)
          ?.productVariantDetails || []
      )
    );
    console.log(this.productVariants[index]);
  }

  getSizeBasedPrice(event: any, index: number) {
    const selectedValue = event.target.value;
    const [size, variantId] = selectedValue.split('|');
    const productNameControl = this.products.at(index).get('size');
    productNameControl?.setValue(size + '|' + variantId, {emitEvent: true});
    console.log(productNameControl.value, size);
    const unitPriceControl = this.products.at(index).get('unitPrice');
    unitPriceControl?.setValue(this.productVariants[index].find(id => id.productVariantId == variantId).productSrp);
  }

  public invoiceErrors = {
    phoneNumber: '',
    customerName: '',
    products: '',
  }

  //on submit
  onSubmit() {
    this.invoiceValidation();
  }

  invoiceValidation() {
    this.invoiceErrors.phoneNumber = "";
    this.invoiceErrors.customerName = "";
    this.invoiceErrors.products = "";

    let hasError = false;

    if (this.invoiceFormGroup.get('phoneNumber')?.invalid) {
      if (this.invoiceFormGroup.get('phoneNumber').errors.required) {
        this.invoiceErrors.phoneNumber = "Phone Number is required";
      }
      if (this.invoiceFormGroup.get('phoneNumber').errors.pattern) {
        this.invoiceErrors.phoneNumber = "Please, Enter 10 digit Valid Phone Number.";
      }
      hasError = true;
    }

    if (this.invoiceFormGroup.get("customerName")?.invalid) {
      this.invoiceErrors.customerName = "Customer Name is required";
      hasError = true;
    }

    const productsArray = this.invoiceFormGroup.get('products') as UntypedFormArray;
    if (productsArray.length === 0) {
      this.invoiceErrors.products = "Please add at least one product to create a bill.";
      this.toastr.error("Please add at least one product to create a bill.");
      hasError = true;
    }

    if (!hasError) {
      const body = this.invoiceFormGroup.value;
      body.products.forEach(element => {
        element.productName = element.productName.split("|")[0];
        element.size = element.size.split("|")[0];
      })
      console.log(`Invoice Form::`, this.invoiceFormGroup.value);
      this.saveInvoiceByAdmin();
    }
  }

  saveInvoiceByAdmin() {
    this.spinner.show();
    this.appService.saveInvoiceDetails(this.invoiceFormGroup.value)
      .subscribe({
        next: (response: BillingDetails) => {
          this.spinner.hide();
          this.invoiceDetails = response;
          console.log(`billed details::`, this.invoiceDetails);
          const billId = this.invoiceDetails.billId;
          const billType = this.invoiceDetails.billType;
          const encryptedBillId = CryptoJS.AES.encrypt(String(billId), this.secretKey).toString();
          const encryptedBillType = CryptoJS.AES.encrypt(String(billType), this.secretKey).toString();
          // this.toastr.success(`Billing details saved successfully`);
          this.router.navigate(['/bill'], {queryParams: {billId: encryptedBillId, billType: encryptedBillType}});
        },
        error: (error) => {
          this.spinner.hide();
          console.error('save invoice details:', error);
          this.toastr.error(error.error.message);
        },
        complete: () => {
          this.spinner.hide();
          console.log('save invoice details completed');
        }
      })
  }


  ngOnDestroy() {
    localStorage.removeItem('lfCustomerDetail');
  }
}
